import React from 'react';
import AdminSidebar from '../components/AdminSidebar';
import AdminNavbar from '../components/AdminNavbar';
import { useSidebar } from '../components/SidebarContext';

const AddNewSection = () => {
  const { isSidebarOpen } = useSidebar();
  const sidebarWidth = isSidebarOpen ? '15.6rem' : '4.4rem';

  const layoutStyles = {
    container: {
      display: 'flex',
      height: '100vh',
      overflow: 'hidden',
      background: 'linear-gradient(to right, #EFF6FF, #F3E8FF, #FEE7EF)',
      fontFamily: "'Roboto', sans-serif",
    },
    sidebar: {
      width: sidebarWidth,
      transition: 'width 0.3s ease',
      overflow: 'hidden',
    },
    content: {
      flex: 1,
      padding: '20px',
      margin: '6rem 2rem 2rem 2rem',
      backgroundColor: 'white',
      overflowY: 'auto',
      borderRadius: '1rem',
      maxWidth: `calc(100vw - ${sidebarWidth} - 4rem)`,
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    },
    sectionBox: {
      marginTop: '2rem',
    },
    buttonsContainer: {
      display: 'flex',
      gap: '1rem',
      marginTop: '1rem',
    },
    button: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0.5rem 1.2rem',
      fontSize: '0.875rem',
      fontWeight: '600',
      color: '#6B21A8',
      textTransform: 'uppercase',
      letterSpacing: '0.05rem',
      cursor: 'pointer',
      borderRadius: '1.5rem',
      border: '2px solid transparent',
      backgroundImage:
        'linear-gradient(#ffffff, #ffffff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF)',
      backgroundOrigin: 'border-box',
      backgroundClip: 'padding-box, border-box',
      transition: 'all 0.4s ease',
    },
    mapSection: {
      marginTop: '3rem',
      padding: '1.5rem',
      border: '1px solid #ddd',
      borderRadius: '10px',
      backgroundColor: '#F9FAFB',
    },
    mapRow: {
      display: 'flex',
      gap: '1rem',
      alignItems: 'center',
      marginTop: '1rem',
    },
    select: {
      padding: '10px',
      borderRadius: '5px',
      border: '1px solid #ccc',
      width: '200px',
    },
  };

  return (
    <div style={layoutStyles.container}>
      <style>
        {`
          .glow-button:hover:not(:disabled) {
            background: linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF);
            transform: scale(1.05);
            animation: glow 1.5s ease-in-out infinite;
          }

          @keyframes glow {
            0% { box-shadow: 0 0 5px #C5A8FF; }
            50% { box-shadow: 0 0 15px #C5A8FF; }
            100% { box-shadow: 0 0 5px #C5A8FF; }
          }
        `}
      </style>

      <AdminNavbar />
      <div style={layoutStyles.sidebar}>
        <AdminSidebar />
      </div>
      <div style={layoutStyles.content}>
        <h2>Add New Section</h2>

        {/* Section Form Placeholder */}
        <div style={layoutStyles.sectionBox}>
          <p>Section form content goes here...</p>

          {/* Add Section & Add Department Buttons */}
          <div style={layoutStyles.buttonsContainer}>
            <button style={layoutStyles.button} className="glow-button">Add Section</button>
            <button style={layoutStyles.button} className="glow-button">Add Department</button>
          </div>
        </div>

        {/* Mapping Section to Branch */}
        <div style={layoutStyles.mapSection}>
          <h3>Map Section to Branch</h3>
          <div style={layoutStyles.mapRow}>
            <select style={layoutStyles.select}>
              <option>Select Section</option>
              <option>Section A</option>
              <option>Section B</option>
            </select>
            <select style={layoutStyles.select}>
              <option>Select Branch</option>
              <option>Computer Science</option>
              <option>Electronics</option>
            </select>
            <button style={layoutStyles.button} className="glow-button">Map</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewSection;
